import React from "react"
import { Flex } from "theme-ui"
import { Link } from "gatsby"
import styled from "@emotion/styled"

const BottomLink = styled(Link)`
    display: flex;
    flex: 0 0 auto;
    width: 30%;
    justify-content: space-between;
    border-top: 1px solid ${(props) => props.theme.colors.primary};
    padding-top: 0.5rem;
    margin-bottom: 1rem;
    & span {
        margin-right: 1rem;
        font-weight: 500;
    }
    &:hover {
        text-decoration: none !important;
        border-top: 3px solid ${(props) => props.theme.colors.primary};
        transition: flex 0.3s linear;
        & .arrow {
            transition: all 0.3s linear;
            width: 4rem !important;
            @media screen and (max-width: ${(props) =>
                    props.theme.breakpoints[3]}) {
                width: 3rem !important;
            }
        }
    }
    & .arrow-wrapper {
        flex: 0 0 20%;
    }
`
const Index = ({ links }) => (
    <Flex sx={{ flexWrap: "wrap", justifyContent: "space-between", width: "100%", my: "1rem" }}>
        {links.map((link, index) => (
            <BottomLink to={link.url} key={index}>
                <span>{link.title}</span>
                <div className="arrow-wrapper">
                    <div className="arrow"></div>
                </div>
            </BottomLink>
        ))}
    </Flex>
)

export default Index
